import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { ReportDepositItem, ReportService } from "@/domains/report";

interface TenantDailyReportDepositState {
  loading: boolean;
  items: ReportDepositItem[];
}

const initialState: TenantDailyReportDepositState = {
  loading: false,
  items: [],
};

export const tenantDailyReportDepositSelects = {
  loading: (state: RootState) => state.tenantDailyReportDeposit.loading,
  items: (state: RootState) => state.tenantDailyReportDeposit.items,
};

export const tenantDailyReportDepositThunks = {
  list: createAsyncThunk("tenantDailyReportDeposit/list", async () => {
    const res = await ReportService.dailyReportDeposit().run();
    return res.data.msg;
  }),
};

export const tenantDailyReportDepositSlice = createSlice({
  name: "tenantDailyReportDeposit",
  initialState,
  reducers: {
    // setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
    //   state.queryParams = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantDailyReportDepositThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tenantDailyReportDepositThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
      }
    );
    builder.addCase(tenantDailyReportDepositThunks.list.rejected, (state) => {
      state.loading = false;
      state.items = [];
    });
  },
});

export const tenantDailyReportDepositActions =
  tenantDailyReportDepositSlice.actions;
